import React, { useMemo } from 'react';

import {
  Container,
  Title,
  SubTitle,
  Text,
  TextsWrapper,
  ButtonOK,
  TitleWrap,
} from './styles';

type ModalInfosProps = {
  closeModal: () => void;
  modalType: 'supplyWay' | 'routeDays';
  isAutomatic?: boolean;
};

const ModalInfos: React.FC<ModalInfosProps> = ({
  closeModal,
  modalType,
  isAutomatic,
}) => {
  const title = useMemo(() => {
    if (modalType === 'supplyWay') {
      return 'Forma de abastecimento';
    }
    return 'Dias de rota';
  }, [modalType]);

  const text = useMemo(() => {
    if (modalType === 'supplyWay') {
      return isAutomatic
        ? 'Com o abastecimento automático da Ultragaz, seu consumo é monitorado de perto, garantindo que você nunca fique sem gás. Já na opção de abastecimento via pedido, você precisa solicitar o reabastecimento manualmente sempre que o nível do tanque estiver baixo.'
        : 'A gestão do seu abastecimento ainda não está conosco, por isso você precisará realizar a solicitação de abastecimento de acordo com a sua necessidade. Nesse caso é importante se atentar aos dias de rota disponíveis na sua região para que possamos realizar a entrega de forma mais assertiva. Para garantir mais comodidade ao seu dia a dia converse com a Ully, a nossa assistente virtual, e altere o seu modelo de abastecimento para o tipo “Automático”.';
    }

    return 'Os dias de rota seguirão os dias da semana definidos previamente, e o tempo de viagem poderá variar entre 1 ou mais dias, dependendo do tipo de dia escolhido para a rota';
  }, [modalType, isAutomatic]);

  return (
    <Container>
      <TitleWrap>
        <Title>{title}</Title>
      </TitleWrap>
      <TextsWrapper>
        {modalType === 'supplyWay' && (
          <SubTitle>{isAutomatic ? 'Automática' : 'Pedido'}</SubTitle>
        )}
        <Text>{text}</Text>
      </TextsWrapper>
      <ButtonOK onClick={() => closeModal()}>Entendi</ButtonOK>
    </Container>
  );
};

ModalInfos.defaultProps = {
  isAutomatic: false,
};

export default ModalInfos;
